import { memo } from 'react';
import styled, { type CSSObject } from '@emotion/styled';

import type { ThemeProps } from '@emotion/react';

import { colorAlpha } from '../../../../lib/colorAlpha';
import NavLink from '../NavLink';

import type { Maybe } from '../../../../types/graphql';
import { useRouteBuilder } from '../../../../lib/hooks/useRouteBuilder';

interface ListWrapProps {
  inPageVersion: boolean;
}

const MobileNavItemStyled = styled('li')`
  text-align: center;
  width: 100%;
  padding: 8px;

  ${(props: ListWrapProps & ThemeProps) =>
    props.inPageVersion &&
    `border-bottom: 1px solid ${colorAlpha(
      props.theme.fonts.s5.color || '',
      '45%'
    )};`}

  ${(props: ThemeProps): CSSObject | undefined =>
    props.theme.components.Nav?.Item}

  :hover,
  :focus {
    background-color: ${(props: ThemeProps): string =>
      colorAlpha(props.theme.fonts.s5.color || '', '10%')};
  }
`;

interface MobileNavItemProps {
  inPageVersion: boolean;
  page: {
    title?: Maybe<string> | undefined;
    routeName?: Maybe<string> | undefined;
  };
  handleTracking(selection: string): void;
  setMobileNavOpen?: ((open: boolean) => void) | undefined;
  shouldScrollToTopOnNavigate?: boolean | undefined;
  activeSinglePageSectionId?: string | undefined;
}

function MobileNavItem({
  page,
  inPageVersion,
  setMobileNavOpen,
  handleTracking,
  shouldScrollToTopOnNavigate = false,
  activeSinglePageSectionId,
}: MobileNavItemProps) {
  const { title, routeName } = page;

  const newRoute = useRouteBuilder(routeName || '');

  const props = {
    href: newRoute,
    as: newRoute,
    desktop: false,
    handleTracking,
    setMobileNavOpen,
    title: title || '',
    route: routeName || '',
    shouldScrollToTopOnNavigate,
    activeSinglePageSectionId,
  };

  return (
    <MobileNavItemStyled inPageVersion={inPageVersion}>
      <NavLink {...props} />
    </MobileNavItemStyled>
  );
}

export default memo(MobileNavItem);
